import { render } from "./RouterView.vue?vue&type=template&id=73521d30"
const script = {}

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__